import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const C = { teal:'#00B4D8', dark:'#1F2937', grey:'#6B7280', border:'#E5E7EB' };

export default function AdminBranding() {
  const [tenant, setTenant] = useState(null);
  const [form, setForm] = useState({ primary_colour:'#00B4D8', secondary_colour:'#0D1B2A', school_name:'', logo_url:'' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/api/admin/dashboard').then(r => {
      const t = r.data?.tenant;
      setTenant(t);
      if (t) setForm({ primary_colour: t.primary_colour||'#00B4D8', secondary_colour: t.secondary_colour||'#0D1B2A', school_name: t.school_name||t.name||'', logo_url: t.logo_url||'' });
    }).catch(()=>{});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/api/admin/tenant/branding', form);
      toast.success('Branding updated!');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  return (
    <Layout role="tenant_admin" tenantColor={tenant?.primary_colour} tenantName={tenant?.school_name}>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(min(100%, 260px), 1fr))', gap:24 }}>
        <div>
          <div className="card" style={{ padding:24, marginBottom:20 }}>
            <h3 style={{ margin:'0 0 20px', fontSize:16, fontWeight:700 }}>School Branding</h3>
            <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
              <div>
                <label style={{ fontSize:13, fontWeight:600, color:C.grey, display:'block', marginBottom:6 }}>School Name</label>
                <input value={form.school_name} onChange={e => setForm({...form, school_name:e.target.value})}
                  style={{ width:'100%', padding:'10px 12px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14 }} />
              </div>
              <div>
                <label style={{ fontSize:13, fontWeight:600, color:C.grey, display:'block', marginBottom:6 }}>Logo URL</label>
                <input placeholder="https://..." value={form.logo_url} onChange={e => setForm({...form, logo_url:e.target.value})}
                  style={{ width:'100%', padding:'10px 12px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14 }} />
              </div>
              <div>
                <label style={{ fontSize:13, fontWeight:600, color:C.grey, display:'block', marginBottom:6 }}>Primary Colour</label>
                <div style={{ display:'flex', gap:12, alignItems:'center' }}>
                  <input type="color" value={form.primary_colour} onChange={e => setForm({...form, primary_colour:e.target.value})}
                    style={{ width:48, height:40, border:'none', borderRadius:8, cursor:'pointer', padding:2 }} />
                  <input value={form.primary_colour} onChange={e => setForm({...form, primary_colour:e.target.value})}
                    style={{ flex:1, padding:'10px 12px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14, fontFamily:'monospace' }} />
                </div>
              </div>
              <div>
                <label style={{ fontSize:13, fontWeight:600, color:C.grey, display:'block', marginBottom:6 }}>Secondary Colour</label>
                <div style={{ display:'flex', gap:12, alignItems:'center' }}>
                  <input type="color" value={form.secondary_colour} onChange={e => setForm({...form, secondary_colour:e.target.value})}
                    style={{ width:48, height:40, border:'none', borderRadius:8, cursor:'pointer', padding:2 }} />
                  <input value={form.secondary_colour} onChange={e => setForm({...form, secondary_colour:e.target.value})}
                    style={{ flex:1, padding:'10px 12px', border:`1px solid ${C.border}`, borderRadius:8, fontSize:14, fontFamily:'monospace' }} />
                </div>
              </div>
            </div>
          </div>
          <button onClick={save} disabled={saving} className="btn-teal" style={{ width:'100%', padding:'12px' }}>
            {saving ? 'Saving...' : 'Save Branding'}
          </button>
        </div>

        {/* Live Preview */}
        <div>
          <div className="card" style={{ padding:24 }}>
            <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:700 }}>Live Preview</h3>
            <div style={{ borderRadius:12, overflow:'hidden', border:`2px solid ${C.border}` }}>
              {/* Preview sidebar */}
              <div style={{ display:'flex', height:200 }}>
                <div style={{ width:120, background:form.primary_colour, padding:16 }}>
                  {form.logo_url ? (
                    <img src={form.logo_url} alt="logo" style={{ width:32, height:32, borderRadius:6, objectFit:'cover', marginBottom:8 }} />
                  ) : (
                    <div style={{ width:32, height:32, borderRadius:6, background:'rgba(255,255,255,0.2)', marginBottom:8, display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <span style={{ color:'#fff', fontSize:14, fontWeight:700 }}>{form.school_name?.[0]||'S'}</span>
                    </div>
                  )}
                  <div style={{ color:'rgba(255,255,255,0.9)', fontSize:11, fontWeight:700, marginBottom:12 }}>{form.school_name||'School'}</div>
                  {['Dashboard','Students','Tutors'].map(item => (
                    <div key={item} style={{ color:'rgba(255,255,255,0.65)', fontSize:10, padding:'4px 0' }}>{item}</div>
                  ))}
                </div>
                <div style={{ flex:1, background:'#F0F7FA', padding:16 }}>
                  <div style={{ background:'#fff', padding:8, borderRadius:6, marginBottom:8, boxShadow:'0 1px 3px rgba(0,0,0,0.1)' }}>
                    <div style={{ fontSize:12, fontWeight:700 }}>Active Students</div>
                    <div style={{ fontSize:18, fontWeight:800, color:form.primary_colour }}>85</div>
                  </div>
                  <div style={{ background:form.primary_colour, color:'#fff', padding:'6px 12px', borderRadius:6, fontSize:11, fontWeight:600, display:'inline-block' }}>
                    Start Lesson →
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
